import { combineReducers } from '@reduxjs/toolkit';

import applicationsSlice, { ICreateApplicationFormState } from './slices/applicationSlice';
import messagesSlice, { IMessagesState } from './slices/messagesSlice';
import modalSlice, { ModalState } from './slices/modalSlice';
import routerSlice, { IRouterState } from './slices/routerSlice';

export interface IState {
  messages: IMessagesState;
  router: IRouterState;
  modal: ModalState;
  applications: ICreateApplicationFormState;
}

const reducer = combineReducers<IState>({
  messages: messagesSlice.reducer,
  router: routerSlice.reducer,
  modal: modalSlice.reducer,
  applications: applicationsSlice.reducer,
});

export default reducer;
